import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    this.$store.dispatch('loadProjects');
    this.$store.dispatch('loadEntries');
  },
  computed: {
    projects() {
      return this.$store.getters.projects
    },
    entries() {
      return this.$store.getters.entries
    },
    errors() {
      return this.$store.getters.errors
    }
  },
  beforeCreate() {
    this.$store.commit('initialiseStore');
  }
}).$mount('#app');
